$(document).ready(function () {
    handleFormSubmit();
    usageChange("#wearableFormModal");

    let wearableVideoButton = document.getElementById("wearablePlay");
    let wearableVideo = document.querySelector('.wearable video');

    if (!wearableVideoButton || !wearableVideo) {
        return
    }
    wearableVideoButton.addEventListener('click', function (event) {
        event.preventDefault();

        wearableVideoButton.remove();
        wearableVideo.setAttribute("controls", '');
        wearableVideo.play();
    });
});

function handleFormSubmit() {
    $('#wearableFormModal form').on('submit', function () {
        let wearableForm = $('#wearableFormModal');
        console.log('wearable form', wearableForm);

        let userName = wearableForm.find('[name=userName]').val(),
            organisation = wearableForm.find('[name=organisation]').val(),
            jobTitle = wearableForm.find('[name=jobTitle]').val(),
            userEmail = wearableForm.find('[name=userEmail]').val(),
            phoneNumber = wearableForm.find('[name=phoneNumber]').val(),
            usageValue = wearableForm.find('[name=usageValue]').val(),
            userMessage = wearableForm.find('[name=userMessage]').val();

        if (!$('.invalid-feedback').is(':visible')) {
            $.ajax({
                url: $('#ajax_url').val(),
                type: "POST",
                cache: false,
                data: {
                    action: 'iyarn_way_send_email',
                    name: userName,
                    organisation: organisation,
                    jobTitle: jobTitle,
                    email: userEmail,
                    phoneNumber: phoneNumber,
                    usageValue: usageValue,
                    message: userMessage,
                },
                success: function (res) {
                    iyarnWaySuccessSend(res);
                    clearUsage();
                }
            });
        }
    });
}

function usageChange(selector) {
    let contactFormUsageElements = $(document).find(`${selector} .usage-list span`);
    let usageElementValue = $(document).find(`${selector} .usage-value`);
    let activeValues = [];

    contactFormUsageElements.click(function (event) {
        let element = event.target;

        contactFormUsageElements.each(function () {
            this.classList.remove('active');
        });

        activeValues = this.dataset.value;
        element.classList.toggle('active')

        usageElementValue.attr('value', activeValues);
    });
}

function clearUsage() {
    $(document).find('.usage-list span').removeClass('active');
    $(document).find('#usageValue').value = '';
}

function iyarnWaySuccessSend(data) {
    let res = data.trim();

    if (res === 'success') {
        if (!$('.toast').length) {
            $('body').append(`
                <div class="toast iyarn-toast" data-delay="8000">
                    <div class="toast-header">
                        <img decoding="async" loading="lazy" src="/wp-content/themes/iyarn/build/img/favicon.png" width="20" height="20" class="rounded-0 mr-2" alt="iyarn logo">
                        <strong class="mr-auto">iyarn</strong>
                        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="toast-body">
                        Thank you. Message sent successfully!
                    </div>
                </div>
            `);
            $('#wearableFormModal').modal('hide');
            $('form').trigger('reset').removeClass('was-validated');
            $('.toast').toast('show');
            $('.toast').on('hidden.bs.toast', function () {
                $('.toast').remove();
            });
        }
    }
}
